import JSPDF from 'jspdf'
import 'jspdf-autotable'

export default function (columns, rows) {
  columns = columns.map(function (c) { return { title: c.label, dataKey: c.id } })
  var doc = new JSPDF('p', 'pt', 'letter')
  doc.setFont('helvetica')
  doc.setFontSize(14)
  doc.autoTable(columns, rows)
  // doc.output('dataurlnewwindow')
  doc.save('report.pdf')
}



//////////////////
// WEBPACK FOOTER
// ./~/ansergy-datatable/lib/downloadPDF.js
// module id = 78
// module chunks = 0